<template>
    <div class="columns">
        <image-gallery :bid="bid.lot"></image-gallery>
        <div class="column is-10">
            <div class="columns is-multiline">
                <div class="column">
                    <span class="title is-4">{{ bid.lot.auction_name }}</span>
                    <span class="subtitle is-6">@{{ bid.lot.lot_date }}</span>
                </div>
                <div class="column has-text-right">
                    <span class="subtitle is-6"><i class="far fa-user-circle"></i> {{ bid.user.name }}</span>
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th scope="col">LOT#:</th>
                        <th scope="col">Type:</th>
                        <th scope="col">Grade:</th>
                        <th scope="col">Km's:</th>
                        <th scope="col">Year:</th>
                        <th scope="col">Color:</th>
                        <th scope="col">CC:</th>
                        <th scope="col">Transmission:</th>
                        <th scope="col">Status:</th>
                        <th scope="col">Result:</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td data-label="Lot#">{{ bid.lot.bid }}</td>
                        <td data-label="Type:">{{ bid.lot.model_type }}</td>
                        <td data-label="Grade:"> {{ bid.lot.grade_en }}</td>
                        <td data-label="Km's:">{{ bid.lot.mileage }},000</td>
                        <td data-label="Year:">{{ bid.lot.model_year }}</td>
                        <td data-label="Color:">{{ bid.lot.color }}</td>
                        <td data-label="CC:">{{ bid.lot.displacement }}</td>
                        <td data-label="Transmission:">{{ bid.lot.transmission }}</td>
                        <td data-label="Status:">
                            <span style="font-size: 8px!important;" :class="statusLabels[bid.status].tagClass">{{ statusLabels[bid.status].label }}</span>
                        </td>
                        <td data-label="Result">{{ bid.result * 1000 | formatNumber}}</td>
                    </tr>
                </tbody>
            </table>
            <bid-buttons  v-if="bidIsOpen(bid.lot_date)" :bid="bid"></bid-buttons>
            <div class="field is-horizontal" style="padding-top: 10px;" v-else>
                <button class="button" disabled>All bids are closed</button>
                <div class="field" style="padding-left: 15px;">
                    <router-link :to="'/single/' + bid.lot.lot_id" class="button" target="_blank">Full info</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bidButtons from './../Buttons/Bids/BidButtons.vue'
    import Gallery from './../Gallery/Gallery.vue'
    import moment from 'moment-timezone'
    export default {
        components: {
            bidButtons: bidButtons,
            imageGallery: Gallery
        },
        props: ['bid'],
        data() {
            return {
                time: null,
                statusLabels: [
                    {
                        tagClass: 'tag is-danger',
                        label: 'Canceled'
                    },
                    {
                        tagClass: 'tag is-link',
                        label: 'Active'
                    },
                    {
                        tagClass: 'tag is-success',
                        label: 'Win'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose to other'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Unsold'
                    },
                    {
                        tagClass: 'tag is-info',
                        label: 'Negotiations'
                    },
                ],
            }
        },
        methods: {
            bidIsOpen(lot_date){
                return true
            }
        }
    }
</script>

<style scoped>
    table {
        border: 1px solid #ccc;
        border-collapse: collapse;
        margin: 0;
        padding: 0;
        width: 100%;
        table-layout: fixed;
    }

    table caption {
        font-size: 1.5em;
        margin: .5em 0 .75em;
    }

    table tr {
        background-color: #f8f8f8;
        border: 1px solid #ddd;
        padding: .35em;
    }

    table th,
    table td {
        padding: .625em;
        text-align: center;
        font-size: .65em;
    }

    table th {
        font-size: .65em;
        letter-spacing: .1em;
        text-transform: uppercase;
    }

    @media screen and (max-width: 600px) {
        table {
            border: 0;
        }

        table caption {
            font-size: 1.3em;
        }

        table thead {
            border: none;
            clip: rect(0 0 0 0);
            height: 1px;
            margin: -1px;
            overflow: hidden;
            padding: 0;
            position: absolute;
            width: 1px;
        }

        table tr {
            border-bottom: 3px solid #ddd;
            display: block;
            margin-bottom: .625em;
        }

        table td {
            border-bottom: 1px solid #ddd;
            display: block;
            font-size: .8em;
            text-align: right;
        }

        table td::before {
            content: attr(data-label);
            float: left;
            font-weight: bold;
            text-transform: uppercase;
        }

        table td:last-child {
            border-bottom: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Card/Content/BidContent.vue